const SESSION_INVALID = {
  CODE: "OTSS000",
  MESSAGE: "SESSION_EXPIRED",
};

export default { SESSION_INVALID };
